<template>
    <card class="card">
        <div class="card-body">
            <h2 class="pt-0 mt-0">
                <i class="fas fa-copy text-primary"></i> {{$t('document.titleadd')}}
            </h2>
            <hr />
            <div>
                <form @submit.prevent>
                    <div class="row">
                        <div class="col-md-12">
                            <fg-input
                                type="text"
                                :label="$t('document.titlec')"
                                :placeholder="$t('document.titlec')"
                                v-model="form.document.title"
                            ></fg-input>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="form-group">
                                <label for="description">{{$t('document.description')}}</label>
                                <textarea class="form-control" v-model="form.document.description"></textarea>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <label for>{{$t('document.uploadfile')}}</label>
                            <b-form-file
                                accept="image/png, image/jpeg, image/jpg, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.openxmlformats-officedocument.presentationml.presentation, application/vnd.openxmlformats-officedocument.presentationml.slideshow, application/vnd.ms-powerpoint"
                                v-model="form.file"
                                placeholder="Choose a file..."
                            ></b-form-file>
                            <small
                                class="text-muted"
                            >{{$t('document.allowedfiletypes')}}</small>
                        </div>
                    </div>
                    <br />
                    <div class="text-left">
                        <p-button type="primary" @click.native.prevent="save">{{$t('document.button.save')}}</p-button>
                    </div>
                    <div class="clearfix"></div>
                </form>
            </div>
        </div>
    </card>
</template>
<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      multiselect: null,
      form: {
        document: { title: "", description: "", file: "" }
      }
    };
  },
  computed: {
    ...mapState("documents", {
      document: "document"
    })
  },
  methods: {
    save() {
      this.$store.commit("documents/set", this.form);
      this.$store
        .dispatch("documents/add", this.form)
        .then(response => {
          this.$router.push({ name: "documents" });
          this.$notify({
            type: "success",
            horizontalAlign: "center",
            message: this.$t('document.message.successadd')
          });
        })
        .catch(error => {
          let msg = "";
          if (error.response.data) {
            msg = error.response.data.errors[0].detail;
          } else {
            msg = error.response.message;
          }
          this.$notify({
            type: "danger",
            horizontalAlign: "center",
            message: msg
          });
        });
    }
  }
};
</script>
<style>
</style>
